import { render, staticRenderFns } from "./CRButtonToggle.vue?vue&type=template&id=35a3a5d2&scoped=true"
import script from "./CRButtonToggle.vue?vue&type=script&lang=js"
export * from "./CRButtonToggle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35a3a5d2",
  null
  
)

export default component.exports